<template>
  <div class="pa-2 pb-0 white">
    <div v-if="!CurrentlySelectedAccount">
      <h4>
        Please select an account to show channels
      </h4>
    </div>
    <v-form ref="accountform" v-model="valid">
      <v-autocomplete
        auto-select-first
        :items="recordsIamAuthorizedOn"
        item-text="account_name"
        item-value="account_name"
        attach
        chips
        clear-icon="mdi-close-circle"
        @click:clear="clearSelectedAccount"
        hide-selected
        label="Messaging Account"
        class="mx-6 mt-2"
        v-model="selectedAccount"
        :search-input.sync="theAcc"
        return-object
        ref="accountSelect"
        @change="submit"
      >
        <template v-slot:selection="{ attr, on, item, selected }">
          <v-chip
            v-bind="attr"
            :input-value="selected"
            color="#78909c"
            class="white--text"
            v-on="on"
          >
            <v-icon left>mdi-coin</v-icon>
            <span v-text="item.account_name"></span>
          </v-chip>
        </template>
      </v-autocomplete>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: { norecordselected: Boolean, recordsIamAuthorizedOn: Array },
  data() {
    return {
      selectedAccount: this.CurrentlySelectedAccount,
      theAcc: this.CurrentlySelectedAccount,
      valid: false
    };
  },
  computed: {
    ...mapGetters({
      CurrentlySelectedAccount: "getCurrentlySelectedAccount"
    })
  },
  watch: {
    CurrentlySelectedAccount: function(newVal) {
      this.selectedAccount = newVal;
    }
  },
  methods: {
    clearSelectedAccount() {
      this.$store.dispatch("selectAccount", null);
    },
    submit() {
      this.$emit("newaccountselected", this.selectedAccount?.account_name);
      this.$store.dispatch(
        "selectAccountLocallyInMessaging",
        this.selectedAccount?.account_name
      );

      // this.$store.dispatch("selectAccount", this.selectedAccount?.account_name);
    }
  }
};
</script>

<style></style>
